import React, {useState, useEffect} from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
import {makeStyles} from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Accessibility from "@material-ui/icons/Accessibility";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Tasks from "components/Tasks/Tasks.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import download from 'downloadjs'

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import InputLabel from "@material-ui/core/InputLabel";

import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import RangeSlider from 'react-dual-rangeslider';
import Slider, {Range} from 'rc-slider';
import 'rc-slider/assets/index.css';
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import fontb from '../../B-NAZANIN.TTF';
import fontb2 from '../../btitr.ttf';
import ReactFontFace from 'react-font-face'
import {Redirect} from "react-router";
import Typography from "@material-ui/core/Typography";
import Grid from '@material-ui/core/Grid';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Charts from "../Charts/Charts";
import InfoChart from "./InfoChart";
import Users from "../users/users"
import {
    dailySalesChart,
    emailsSubscriptionChart,
    completedTasksChart
} from "../Charts/Charts2";

import DeleteIcon from '@material-ui/icons/Delete';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import KeyboardVoiceIcon from '@material-ui/icons/KeyboardVoice';
import SaveIcon from '@material-ui/icons/Save';
import Slide from '@material-ui/core/Slide';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(styles);
let theme2 = createMuiTheme();

const style = {width: 400, margin: 50};
theme2.typography.h2 = {
    [theme2.breakpoints.up('md')]: {
        fontSize: 25,
    },
    [theme2.breakpoints.down('sm')]: {
        fontSize: 19,
    },
};
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function log(value) {
    console.log(value); //eslint-disable-line
}

let fontConfig = {

    file: [
        {
            fontFamily: 'Bnazanin',
            fontStyle: 'normal',
            fontWeight: 400,
            file: fontb,
            fontType: 'truetype',
        },
        {
            fontFamily: 'Btitr',
            fontStyle: 'normal',
            fontWeight: 400,
            file: fontb2,
            fontType: 'truetype',
        }


    ]
}
const MatchMediaWrapper = ({mobileContent, desktopContent}) => {
    const [isNarrowScreen, setIsNarrowScreen] = useState(false)
    useEffect(() => {
        const mediaWatcher = window.matchMedia("(max-width: 1230px)")
        setIsNarrowScreen(mediaWatcher.matches);

        function updateIsNarrowScreen(e) {
            setIsNarrowScreen(e.matches);
        }

        if (mediaWatcher.addEventListener) {
            mediaWatcher.addEventListener('change', updateIsNarrowScreen)
            return function cleanup() {
                mediaWatcher.removeEventListener('change', updateIsNarrowScreen)
            }
        } else {
            mediaWatcher.addListener(updateIsNarrowScreen)
            return function cleanup() {
                mediaWatcher.removeListener(updateIsNarrowScreen)
            }
        }
    })
    return isNarrowScreen ? mobileContent : desktopContent;
}

class LDA extends React.Component {
    constructor(props) {
        super(props);
        // if (props.location.state){
        this.state = {
            // checkedPos1: null,
            // checkedPos2:null,
            classes: makeStyles(styles),
            input: [],
            action: false,
            category: null,
            checked1: false,
            checked2: false,
            checked3: false,

            setChecked: false,
            min: 1380,
            max: 1399,
            min0:1306,
            value2: 1390,
            value4: 'زبان',
            imageuri: null,
            response: null,
            ht: null,
            NTopic: 0,
            NWord: 0,
            ShowImage: null,
            Load: false,
            index_get_sample: null,
            // token: props.location.state.token,
            // Email: props.location.state.email,
            UserName: "",
            token: "",

            NAllDoc:0,
            NWAllDoc:0,
            NWUAllDoc:0,

            NAllLBDoc:0,
            NWAllLBDoc:0,
            NWUAllLBDoc:0,

            NAllUNLBDoc:0,
            NWAllUNLBDoc:0,
            NWUAllUNLBDoc:0,

            NSpecificLBDoc:0,
            NWSpecificLBDoc:0,
            NWUSpecificLBDoc:0,

            NSpecificUNLBDoc:0,
            NWSpecificUNLBDoc:0,
            NWUSpecificUNLBDoc:0,

            NAllSpecificDoc:0,
            NWAllSpecificDoc:0,
            NWUAllSpecificDoc:0,

            NSample: 0,
            samples: null,
            open: false,
            open2: false,
            NTopicsExist: false,
            NTopics: null,
            years: null

        };

        this.handleChange3 = this.handleChange3.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange1 = this.handleChange1.bind(this);
    }

    onSliderChange = value => {
        log(value);
    };

    onMinChange = e => {
        this.setState({
            min: e.target.value,
        });
    };
    onValueChange = e => {
        this.setState({
            value2: +e.target.value || 0,
        });
    };
    handleChange = e => {
        if (e.target.value >= 0) {
            this.setState({
                NTopic: +e.target.value || 0,
            });
        }
    };
    handleChange1 = e => {
        if (e.target.value >= 0) {
            if (e.target.value <= 20) {
                this.setState({
                    NWord: +e.target.value || 0,
                });
            }

        }

    };
    onMaxChange = e => {
        this.setState({
            max: e.target.value,
        });
    };

    handleChange3(event) {
        console.log("event.target.value")
        console.log(event.target.value)
        fetch("http://conalysis.ihcs.ac.ir:8080/determine_year", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                subject: event.target.value,
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    years: responseJson,
                })
                console.log(responseJson);


            })
            .catch((error) => {
                console.log(error);
            });
        fetch("http://conalysis.ihcs.ac.ir:8080/determine_ntopic", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                subject: event.target.value,
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {

                console.log(responseJson);
                if (responseJson.exist) {

                    this.setState({
                        NTopics: responseJson.topic_ids,
                        NTopicsExist: true,
                        NTopic: responseJson.topic_ids[0].ntopic,
                    })

                } else {
                    this.setState({
                        NTopicsExist: false,
                    })

                }


            })
            .catch((error) => {
                console.log(error);
            });
        // console.log(this.state.value);
        this.setState({value4: event.target.value});

    }

    handleClickOpen2(type1, topic_id, topic_id2, option, index) {
        if (type1 == 1) {
            fetch("http://conalysis.ihcs.ac.ir:8080/get_similarity", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({

                    type: 1,
                    topic_id: option[0] + ",type0",
                    topic_number: option[0],
                    subject: option[5],
                    ntopic: option[6],                   // article_id:0,
                    // type:'1',
                }),
            })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log("responseJson");
                    console.log(responseJson);
                    this.setState({
                        open2: true,
                        similarity: responseJson,
                        index_get_sample: index + 1
                    })


                })
                .catch((error) => {
                    console.log(error);
                });


        } else {
            fetch("http://conalysis.ihcs.ac.ir:8080/get_similarity", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    type: 2,
                    // topic_id: topic_id+","+"",
                    // article_id:article_id,
                    topic_id: topic_id,
                    topic_number: topic_id2,
                    subject: option[5],
                    ntopic: option[6],
                    index_get_sample: index + 1// type:'1',
                }),
            })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log("responseJson");
                    console.log(responseJson);
                    this.setState({
                        // open:true,
                        similarity: responseJson
                    })
                })
                .catch((error) => {
                    console.log(error);
                });

        }

    };


    handleClickOpen(option, NSample, index) {
        console.log(option)
        console.log(index)
        fetch("http://conalysis.ihcs.ac.ir:8080/get_samples", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                // NSample: this.state.input_sample[index],
                topic_id: option[0],
                subject: option[5],
                ntopic: option[6],
                NSample: NSample,

                // topic_id: topic_id,
                // type:'1',
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log("responseJson");
                console.log(responseJson);
                this.setState({
                    open: true,
                    samples: responseJson,
                    index_get_sample: index + 1
                })
            })
            .catch((error) => {
                console.log(error);
            });


        // setOpen(true);
    };

    handleClose() {
        this.setState({
            open: false
        })
    };

    handleClose2() {
        this.setState({
            open2: false
        })
    };

    handleChange10 = e => {
        if (e.target.value >= 0) {
            this.setState({
                NSample: +e.target.value || 0,
            });
        }
    };

    handleSubmit(event) {
        alert('Your favorite flavor is: ' + this.state.value);
        event.preventDefault();
    }

    async componentDidMount() {
        await fetch("http://conalysis.ihcs.ac.ir:8080/determine_year", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                subject: 'زبان',
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    years: responseJson,
                })
                console.log(responseJson);


            })
            .catch((error) => {
                console.log(error);
            });
        await fetch("http://conalysis.ihcs.ac.ir:8080/determine_ntopic", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                // label: this.state.input[index],
                subject: 'زبان',
                // topic_version:value.topics_version,
                // email:this.props.location.state.email
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                //   console.log("hello")
                console.log(responseJson);
                if (responseJson.exist) {

                    this.setState({
                        NTopics: responseJson.topic_ids,
                        NTopicsExist: true,
                        NTopic: responseJson.topic_ids[0].ntopic,
                    })
                } else {
                    this.setState({
                        NTopicsExist: false,
                    })

                }


            })
            .catch((error) => {
                console.log(error);
            });


    }
    createData(name, calories, fat,fat2) {
        return { name, calories, fat,fat2 };
    }
    render() {
        // const rows;
        // if(this.state.value4==='زبان'){
        //     const rows = [

        //
        //     ];
        // }
        // else{
            let category;
            if(this.state.value4==='زبان'){
                category = "زبان‌شناسی"

            }
            else{

                category = this.state.value4
            }
            const rows = [
                this.createData('کل حوزه‌ها', this.state.NAllDoc, this.state.NWAllDoc,this.state.NWUAllDoc),
                this.createData(' کل حوزه‌ها (برچسب‌دار اولیه)', this.state.NAllLBDoc, this.state.NWAllLBDoc,this.state.NWUAllLBDoc),
                this.createData('  کل حوزه‌ها (برچسب‌گذاری‌شده) ', this.state.NAllUNLBDoc, this.state.NWAllUNLBDoc,this.state.NWUAllUNLBDoc),
                this.createData(" کل "+category,this.state.NWUAllSpecificDoc, this.state.NWAllSpecificDoc,this.state.NAllSpecificDoc),
                this.createData(category+" (برچسب‌دار اولیه) " ,this.state.NSpecificLBDoc, this.state.NWSpecificLBDoc,this.state.NWUSpecificLBDoc),
                this.createData(category+" (برچسب‌گذاری‌شده) ",this.state.NSpecificUNLBDoc, this.state.NWSpecificUNLBDoc,this.state.NWUSpecificUNLBDoc),
            

            ];
        // }

        const {
            state: {domain, values, update, reversed},
        } = this;
        // if (this.state.token !== 1){
        return (

            <div>
                <GridContainer>
                    <Button
                        className="button"
                        style={{
                            marginTop: "-5%",
                            marginRight: "95%",
                            borderRadius: "20px",
                            fontFamily: "Btitr",
                            fontSize: 16,
                            width: "2%",
                            height: "3%",
                            backgroundColor: "rgb(0,191,214)"
                        }}
                        onClick={() => {
                            this.setState({
                                action: true
                            })
                        }

                        }
                    >
                        خروج
                    </Button>
                    {
                        this.state.action ? <div>{this.check22()}</div> : null
                    }
                    {/* <div style={{marginTop:"-5%",marginRight:"97%"}}>hello</div> */}
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary">
                                <h4 className={this.state.classes.cardTitleWhite}
                                    style={{fontFamily: 'Bnazanin', fontSize: 29}}>اطلاعات آماری مستندات</h4>
                                {/* <p className={this.state.classes.cardCategoryWhite}> */}
                                {/*New employees on 15th September, 2016*/}
                                {/* </p> */}
                            </CardHeader>
                            <CardBody>

                                <div style={{flexDirection: "row", display: "flex"}}>
                                    <div style={{width: "40%"}}>
                                        {/*<form onSubmit={this.handleSubmit}>*/}
                                        {/*    <label>*/}
                                        {/*        Pick your favorite flavor:*/}
                                        <InputLabel style={{
                                            width: "100%",
                                            fontSize: 25,
                                            fontFamily: 'Bnazanin',
                                            color: "black"
                                        }} htmlFor="select">حوزه علمی:</InputLabel>
                                        <select style={{
                                            fontFamily: 'Bnazanin',
                                            width: "auto",
                                            fontSize: 19,
                                            marginTop: "5%"
                                        }} value={this.state.value4} onChange={this.handleChange3}>
                                            <option value="اقتصاد"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>اقتصاد
                                            </option>
                                            <option value="ادبیات"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>ادبیات
                                            </option>
                                            <option value="تربیت بدنی"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>تربیت بدنی
                                            </option>
                                            <option value="تاریخ" style={{fontFamily: 'Bnazanin', fontSize: 25}}>تاریخ
                                            </option>
                                            <option value="جغرافیا"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>جغرافیا
                                            </option>
                                            <option value="حقوق" style={{fontFamily: 'Bnazanin', fontSize: 25}}>حقوق
                                            </option>
                                            <option value="روانشناسی علوم تربیتی"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>روان‌شناسی و علوم  تربیتی
                                            </option>
                                            <option value="زبان" style={{fontFamily: 'Bnazanin', fontSize: 25}}>زبان‌شناسی
                                            </option>
                                            {/* <option value="سیاست" style={{fontFamily:'Bnazanin',fontSize:25}}>سیاست</option> */}
                                            {/* <option value="علوم انسانی" style={{fontFamily:'Bnazanin',fontSize:25}}>علوم انسانی</option> */}
                                            <option value="علوم اسلامی"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم اسلامی
                                            </option>
                                            <option value="علوم کتابداری"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم کتابداری
                                            </option>
                                            <option value="علوم اجتماعی ارتباطات"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم اجتماعی  و ارتباطات
                                            </option>
                                            <option value="علوم سیاسی روابط الملل"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم سیاسی و روابط  بین‌الملل
                                            </option>
                                            <option value="فلسفه منطق"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>فلسفه و منطق
                                            </option>
                                            <option value="مدیریت حسابداری"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>مدیریت و حسابداری
                                            </option>

                                            <option value="مطالعات هنر"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>مطالعات هنر
                                            </option>


                                            <option value="مطالعات زنان"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>مطالعات زنان
                                            </option>


                                        </select>
                                    </div>
                                </div>
                                <Grid Container fluid style={{justifyContent: 'row', display: "flex", width: "100%"}}>
                                    <Grid item xs={9} sm={9} md={9} lg={9}>
                                        <p style={{marginTop: "4%", fontFamily: 'Bnazanin', fontSize: 25}}>
                                            تاریخ انتشار متون علمی:
                                        </p>
                                    </Grid>
                                </Grid>


                                <div style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    // backgroundColor:"blue",
                                    fontSize: 19,
                                    alignItems: "center",
                                    width: "100%",
                                    // background:"black"

                                }}>

                                    <Checkbox
                                        checked={this.state.checked1}

                                        onChange={() => {
                                            if (this.state.checked1 === true) {
                                                this.setState({
                                                    checked1: false,
                                                });

                                            } else if (this.state.checked2 === false) {

                                                this.setState({
                                                    checked1: true,
                                                    checked3:false
                                                });
                                            } else if (this.state.checked2 === true) {
                                                this.setState({
                                                    checked1: true,
                                                    checked2: false,
                                                    checked3:false
                                                });
                                            }
                                            else if (this.state.checked3 === false) {

                                                this.setState({
                                                    checked1: true,
                                                    checked3:false,
                                                    checked2:false
                                                });
                                            } else if (this.state.checked3 === true) {
                                                this.setState({
                                                    checked1: true,
                                                    checked2: false,
                                                    checked3:false
                                                });
                                            }

                                        }}
                                        inputProps={{'aria-label': 'primary checkbox'}}
                                    />
                                    <ThemeProvider theme={theme2}>
                                        <Typography variant="h2" style={{fontFamily: 'Bnazanin'}}> بازه زمانی

                                        </Typography>
                                    </ThemeProvider>

                                    <label style={{
                                        fontFamily: 'Bnazanin',
                                        fontSize: 25,
                                        marginRight: "2%",
                                        color: "black"
                                    }}>از
                                    </label>
                                    <Grid xs={2} sm={1} md={1} lg={1} style={{marginRight: "1%"}}>
                                        <InputLabel style={{
                                            width: "100%",
                                            fontSize: 25,
                                            fontFamily: 'Bnazanin',
                                            color: "black"
                                        }} htmlFor="select"/>
                                        <select style={{
                                            fontFamily: 'Bnazanin',
                                            width: "auto",
                                            fontSize: 19,
                                            marginTop: "5%"
                                        }} value={this.state.min} onChange={this.onMinChange}>
                                            {
                                                this.state.years ?
                                                    this.state.years.map((item, index) => {

                                                        return (
                                                            <option value={item}
                                                                    style={{
                                                                        fontFamily: 'Bnazanin',
                                                                        fontSize: 25
                                                                    }}>{item}
                                                            </option>

                                                        )
                                                    })
                                                    : null
                                            }


                                        </select>

                                        {/*<Input disabled={!this.state.checked1}*/}
                                        {/*       style={{width: "100%",fontFamily: "Bnazanin",fontSize: 19}}*/}
                                        {/*       type="number" value={this.state.min}*/}
                                        {/*       onChange={this.onMinChange}/>*/}
                                        {/* </Grid> */}
                                    </Grid>
                                    <label style={{
                                        // width: "15%",
                                        color: "black",
                                        fontFamily: 'Bnazanin', fontSize: 25,
                                        marginRight: "5%"
                                    }}>تا </label>
                                    <Grid item xs={2} sm={1} md={1} lg={1} style={{marginRight: "1%"}}>
                                        <InputLabel style={{
                                            width: "100%",
                                            fontSize: 25,
                                            fontFamily: 'Bnazanin',
                                            color: "black"
                                        }} htmlFor="select" disabled={!this.state.checked1}/>
                                        <select style={{
                                            fontFamily: 'Bnazanin',
                                            width: "auto",
                                            fontSize: 19,
                                            marginTop: "5%"
                                        }} value={this.state.max} onChange={this.onMaxChange}>
                                            {
                                                this.state.years ?
                                                    this.state.years.map((item, index) => {

                                                        return (
                                                            <option value={item}
                                                                    style={{
                                                                        fontFamily: 'Bnazanin',
                                                                        fontSize: 25
                                                                    }}>{item}
                                                            </option>

                                                        )
                                                    })
                                                    : null
                                            }



                                        </select>
                                        {/*<input disabled={!this.state.checked1}*/}
                                        {/*       style={{width: "100%",fontFamily: "Bnazanin",fontSize: 19}}*/}
                                        {/*       type="number" value={this.state.max}*/}
                                        {/*       onChange={this.onMaxChange}/>*/}
                                    </Grid>
                                </div>
                                <div style={{
                                    marginTop: "3%",
                                    // height: "40%",
                                    flexDirection: "row",
                                    display: "flex",
                                    alignItems: "center",
                                }}>
                                    <Checkbox
                                        checked={this.state.checked2}
                                        onChange={() => {
                                            if (this.state.checked2 === true) {
                                                this.setState({
                                                    checked2: false,
                                                    
                                                });

                                            } else if (this.state.checked1 === false) {


                                                this.setState({
                                                    checked2: true,
                                                    checked3:false
                                                });
                                            } else if (this.state.checked1 === true) {
                                                this.setState({
                                                    checked2: true,
                                                    checked1: false,
                                                    checked3:false
                                                });
                                            }

                                            else if (this.state.checked3 === false) {


                                                this.setState({
                                                    checked2: true,
                                                    checked3:false,
                                                    checked1:false
                                                });
                                            } else if (this.state.checked3 === true) {
                                                this.setState({
                                                    checked2: true,
                                                    checked1: false,
                                                    checked3:false
                                                });
                                            }
                                        }}
                                        inputProps={{'aria-label': 'primary checkbox'}}
                                    />
                                    <ThemeProvider theme={theme2}>
                                        <Typography variant="h2" style={{fontFamily: 'Bnazanin'}}> سال

                                        </Typography>
                                    </ThemeProvider>




                                    <Grid item xs={2} sm={2} md={1} lg={1} style={{marginRight: "1%"}}>
                                        {/* <input disabled={!this.state.checked1} */}

                                        <InputLabel style={{
                                            width: "100%",
                                            fontSize: 25,
                                            fontFamily: 'Bnazanin',
                                            color: "black"
                                        }} htmlFor="select"/>
                                        <select style={{
                                            fontFamily: 'Bnazanin',
                                            width: "auto",
                                            fontSize: 19,
                                            marginTop: "5%"
                                        }} value={this.state.value2} onChange={this.onValueChange}>
                                            {
                                                this.state.years ?
                                                    this.state.years.map((item, index) => {

                                                        return (
                                                            <option value={item}
                                                                    style={{
                                                                        fontFamily: 'Bnazanin',
                                                                        fontSize: 25
                                                                    }}>{item}
                                                            </option>

                                                        )
                                                    })
                                                    : null
                                            }


                                        </select>
                                        {/*<input disabled={!this.state.checked2}*/}
                                        {/*       style={{width: "100%",fontFamily: "Bnazanin",fontSize: 19}}*/}
                                        {/*       type="number" value={this.state.value2}*/}
                                        {/*       onChange={this.onValueChange}/>*/}
                                    </Grid>

                                </div>
                               { /* new*/}
                                <div
                                style={{
                                    marginTop: "3%",
                                    // height: "40%",
                                    flexDirection: "row",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                                >



                                    <Checkbox
                                        checked={this.state.checked3}
                                        onChange={() => {
                                            if (this.state.checked3 === true) {
                                                this.setState({
                                                    checked3: false,

                                                });

                                            } else if (this.state.checked1 === false) {


                                                this.setState({
                                                    checked3: true,
                                                    checked2:false
                                                });
                                            } else if (this.state.checked1 === true) {
                                                this.setState({
                                                    checked3: true,
                                                    checked2: false,

                                                    checked1:false
                                                });
                                            }


                                         else if (this.state.checked2 === false) {


                                            this.setState({
                                                checked3: true,
                                                checked2:false
                                            });
                                        } else if (this.state.checked2 === true) {
                                            this.setState({
                                                checked3: true,
                                                checked2: false,

                                                checked1:false
                                            });
                                        }

                                        }}
                                        inputProps={{'aria-label': 'primary checkbox'}}
                                    />
                                    <ThemeProvider theme={theme2}>
                                        <Typography variant="h2" style={{fontFamily: 'Bnazanin'}}>بدون محدودیت زمانی

                                        </Typography>
                                    </ThemeProvider>
                                    
                                </div>

                                <div
                                    style={{marginTop: "6%", width: "100%", display: 'flex', justifyContent: "center"}}>
                                    <Button
                                        className="button"
                                        style={{
                                            fontFamily: "Btitr",
                                            fontSize: 19,
                                            width: "20%",
                                            backgroundColor: "rgb(151,75,177)"
                                        }}
                                        onClick={() => this.sentLDAData()}
                                        // onClick={this.handleSubmit}
                                    >
                                        دریافت اطلاعات
                                    </Button>
                                </div>
                                {
                                    this.state.Load ?
                                        <div style={{width: "100%", display: 'flex', justifyContent: "center"}}>
                                            {/*<LinearProgress />*/}
                                            <CircularProgress size={70}/>
                                        </div> : null
                                }


                                {this.state.response ?
                                    <div style={{
                                        marginTop:"5%",
                                        position: "relative",
                                        direction: "rtl"
                                    }}>
                                        <InfoChart rows={rows}/>
                                    </div>
                                    : null

                                }


                            </CardBody>
                        </Card>


                    </GridItem>

                </GridContainer>

            </div>
        );

    }

    sentLDAData() {
        if (this.state.checked1) {


            this.setState({
                response:null,
                Load: true,
            });
            console.log(this.state.min,this.state.max);

            fetch("http://conalysis.ihcs.ac.ir:8080/articles_info", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    subject: this.state.value4,
                    minyear: this.state.min,
                    maxyear: this.state.max,
                    email: this.props.location.state.email,
                    type: 1,
                }),
            })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log(responseJson);

                    this.setState({
                        response: responseJson,
                        NAllDoc:responseJson[0],
                        NWAllDoc:responseJson[1],
                        NWUAllDoc:responseJson[2],

                        NAllLBDoc:responseJson[3],
                        NWAllLBDoc:responseJson[4],
                        NWUAllLBDoc:responseJson[5],

                        NAllUNLBDoc:responseJson[6],
                        NWAllUNLBDoc:responseJson[7],
                        NWUAllUNLBDoc:responseJson[8],

                        NSpecificLBDoc:responseJson[9],
                        NWSpecificLBDoc:responseJson[10],
                        NWUSpecificLBDoc:responseJson[11],

                        NSpecificUNLBDoc:responseJson[12],
                        NWSpecificUNLBDoc:responseJson[13],
                        NWUSpecificUNLBDoc:responseJson[14],
                        NAllSpecificDoc:responseJson[15],
                        NWAllSpecificDoc:responseJson[16],
                        NWUAllSpecificDoc:responseJson[17],

                        Load: false,
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        } else if (this.state.checked2) {

            this.setState({
                response: null,
                Load: true,
            });
            fetch("http://conalysis.ihcs.ac.ir:8080/articles_info", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    subject: this.state.value4,
                    year: this.state.value2,
                    type: 2,
                }),
            })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log(responseJson);

                    this.setState({
                        response: responseJson,

                        NAllDoc:responseJson[0],
                        NWAllDoc:responseJson[1],
                        NWUAllDoc:responseJson[2],

                        NAllLBDoc:responseJson[3],
                        NWAllLBDoc:responseJson[4],
                        NWUAllLBDoc:responseJson[5],

                        NAllUNLBDoc:responseJson[6],
                        NWAllUNLBDoc:responseJson[7],
                        NWUAllUNLBDoc:responseJson[8],

                        NSpecificLBDoc:responseJson[9],
                        NWSpecificLBDoc:responseJson[10],
                        NWUSpecificLBDoc:responseJson[11],

                        NSpecificUNLBDoc:responseJson[12],
                        NWSpecificUNLBDoc:responseJson[13],
                        NWUSpecificUNLBDoc:responseJson[14],

                        NAllSpecificDoc:responseJson[15],
                        NWAllSpecificDoc:responseJson[16],
                        NWUAllSpecificDoc:responseJson[17],


                        Load: false,
                    });
                })
                .catch((error) => {
                    console.log(error);
                });

        } 
        
       else if (this.state.checked3) {


            this.setState({
                response:null,
                Load: true,
            });
            console.log(this.state.min0,this.state.max);

            fetch("http://conalysis.ihcs.ac.ir:8080/articles_info", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    subject: this.state.value4,
                    minyear: this.state.min0,
                    maxyear: this.state.max,
                    email: this.props.location.state.email,
                    type: 1,
                }),
            })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log(responseJson);

                    this.setState({
                        response: responseJson,
                        NAllDoc:responseJson[0],
                        NWAllDoc:responseJson[1],
                        NWUAllDoc:responseJson[2],

                        NAllLBDoc:responseJson[3],
                        NWAllLBDoc:responseJson[4],
                        NWUAllLBDoc:responseJson[5],

                        NAllUNLBDoc:responseJson[6],
                        NWAllUNLBDoc:responseJson[7],
                        NWUAllUNLBDoc:responseJson[8],

                        NSpecificLBDoc:responseJson[9],
                        NWSpecificLBDoc:responseJson[10],
                        NWUSpecificLBDoc:responseJson[11],

                        NSpecificUNLBDoc:responseJson[12],
                        NWSpecificUNLBDoc:responseJson[13],
                        NWUSpecificUNLBDoc:responseJson[14],
                        NAllSpecificDoc:responseJson[15],
                        NWAllSpecificDoc:responseJson[16],
                        NWUAllSpecificDoc:responseJson[17],

                        Load: false,
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        else {
            alert("تعیین زمان یا بازه زمانی انتشار متون علمی را انتخاب کنید")

        }

    }


    check22() {
        if (this.state.action) {
            //   console.log("entered");
            return (
                // <BrowserRouter>
                <Redirect
                    to={{
                        pathname: "/",
                        // state: {
                        //   token: this.state.token,
                        //   UserName: this.state.UserName,
                        // },
                    }}
                />
                // </BrowserRouter>
            );
        }
    }

}

export default ReactFontFace(LDA, fontConfig);

